import React, { useState } from "react";

const categorias = [
	{ id: "todos", label: "todos" },
	{ id: "clasicos", label: "the classics" },
	{ id: "lattes", label: "lattes" },
	{ id: "brews", label: "brews & tonics" },
	{ id: "matcha", label: "matchas" },
	{ id: "fizzy", label: "fizzy" },
	{ id: "frappe", label: "frappés" },
	{ id: "eats", label: "good eats" },
	{ id: "smoothie", label: "smoothies" },
	{ id: "extras", label: "extras" },
];

const secciones = [
	{
		id: "clasicos",
		titulo: "the classics",
		subtitulo: "Hot & Cold · 12oz / 16oz / 20oz",
		emoji: "☕",
		color: "#2D6B6B",
		items: [
			{ nombre: "Espresso", precio: "$50", desc: "2 oz" },
			{ nombre: "Cortado", precio: "$60", desc: "4 oz" },
			{ nombre: "Flat White", precio: "$65", desc: "6 oz" },
			{ nombre: "Espresso Americano", precio: "$55/65/75", desc: "" },
			{ nombre: "Cappuccino", precio: "$74/84/95", desc: "" },
			{ nombre: "Latte", precio: "$74/84/95", desc: "" },
			{ nombre: "Mocha", precio: "$89/98/108", desc: "" },
			{ nombre: "White Mocha", precio: "$89/98/108", desc: "" },
			{ nombre: "Chai Latte", precio: "$86/95/105", desc: "" },
			{ nombre: "Chocolate", precio: "$86/95/105", desc: "" },
			{ nombre: "Tisana", precio: "$69/80/92", desc: "" },
		],
	},
	{
		id: "lattes",
		titulo: "lattes with a twist",
		subtitulo: "Hot & Cold · 12oz / 16oz / 20oz",
		emoji: "🌀",
		color: "#F07E2A",
		items: [
			{ nombre: "Caramel Latte", precio: "$89/99/110", desc: "" },
			{ nombre: "Salted Caramel Latte", precio: "$89/99/110", desc: "" },
			{ nombre: "Honey Latte", precio: "$89/99/110", desc: "" },
			{ nombre: "Salted Honey Latte", precio: "$89/99/110", desc: "" },
			{ nombre: "Vanilla Latte", precio: "$89/99/110", desc: "" },
			{ nombre: "Cinnamon Latte", precio: "$89/99/110", desc: "" },
		],
	},
	{
		id: "lattes",
		titulo: "lattes gone wild",
		subtitulo: "Cold · 16oz / 20oz",
		emoji: "🤩",
		color: "#E84023",
		items: [
			{
				nombre: "Dossis Latte",
				precio: "$90/110",
				desc: "Shaken espresso doble con jarabe de azúcar mascabado y leche.",
			},
			{
				nombre: "Biscoff Cloud Latte",
				precio: "$120/140",
				desc: "Espresso doble con jarabe de Biscoff, leche y cold foam de Biscoff.",
			},
			{
				nombre: "Banana Cloud Latte",
				precio: "$110/130",
				desc: "Espresso doble con jarabe de crema de banana, leche y cold foam de banana.",
			},
		],
	},
	{
		id: "brews",
		titulo: "brews & tonics",
		subtitulo: "Cold · 12oz / 16oz / 20oz",
		emoji: "🧊",
		color: "#8BBFD4",
		items: [
			{ nombre: "Cold Brew", precio: "$70/80/90", desc: "" },
			{ nombre: "Espresso Tonic", precio: "$90/98/107", desc: "" },
			{ nombre: "Cold Brew Tonic", precio: "$90/98/107", desc: "" },
		],
	},
	{
		id: "matcha",
		titulo: "addicted to green",
		subtitulo: "Hot & Cold · 12oz / 16oz / 20oz",
		emoji: "🍵",
		color: "#2D6B6B",
		items: [
			{
				nombre: "Matcha Latte",
				precio: "$92/99/108",
				desc: "Matcha ceremonial y leche. Endulzado al gusto con miel de agave.",
			},
		],
	},
	{
		id: "matcha",
		titulo: "matcha, but make it extra",
		subtitulo: "Cold · 16oz / 20oz",
		emoji: "✨",
		color: "#2D6B6B",
		items: [
			{
				nombre: "Vanilla Cloud Matcha",
				precio: "$115/135",
				desc: "Matcha ceremonial, jarabe de vainilla, leche y cold foam de vainilla.",
			},
			{
				nombre: "Strawberry Cloud Matcha",
				precio: "$120/140",
				desc: "Matcha ceremonial, puré de fresa hecho en casa, leche y cold foam de fresa.",
			},
		],
	},
	{
		id: "fizzy",
		titulo: "light & fizzy",
		subtitulo: "Cold · 16oz / 20oz",
		emoji: "🫧",
		color: "#F5C917",
		items: [
			{
				nombre: "Strawberry Fizz",
				precio: "$65/80",
				desc: "Agua mineral con un toque de jarabe de fresa, servida con hielo.",
			},
			{
				nombre: "Lemonade Fizz",
				precio: "$65/80",
				desc: "Limonada con agua mineral, servida con hielo.",
			},
			{
				nombre: "Pink Lemonade Fizz",
				precio: "$70/85",
				desc: "Limonada con agua mineral y un toque de jarabe de pitaya, servida con hielo.",
			},
		],
	},
	{
		id: "frappe",
		titulo: "ice rules! frappé",
		subtitulo: "16oz / 20oz",
		emoji: "🥤",
		color: "#8BBFD4",
		items: [
			{
				nombre: "Coffee-Free Frappé",
				precio: "$99/115",
				desc: "Vainilla · Chocolate · Matcha",
			},
			{
				nombre: "Coffee-Based Frappé",
				precio: "$109/125",
				desc: "Vainilla · Mocha · White Mocha · Caramelo · Avellana · Cream Banana · Biscoff",
			},
		],
	},
	{
		id: "eats",
		titulo: "good eats",
		subtitulo: "",
		emoji: "🥐",
		color: "#F07E2A",
		items: [
			{
				nombre: "Egg Boat",
				precio: "$159",
				desc: "Croissant con huevos fritos o revueltos, jamón o tocino, queso suizo y cebollín. Acompañado de ensalada de la casa.",
			},
			{
				nombre: "Bagel Dossis",
				precio: "$119",
				desc: "Bagel con queso crema preparado con pistache, frutos secos, tocino y un toque de miel.",
			},
			{
				nombre: "Bagel Huevo y Tocino",
				precio: "$149",
				desc: "Bagel con huevo revuelto, tocino, cebollín y queso suizo.",
			},
			{
				nombre: "Croissant Jamón y Queso",
				precio: "$89",
				desc: "Croissant con jamón de pavo, queso suizo y aderezo de la casa.",
			},
			{
				nombre: "Baguette Europea",
				precio: "$199",
				desc: "Baguette con jamón serrano o chorizo español o salchichón o chistorra, tomates asados a las finas hierbas, queso parmesano reggiano y aderezo de la casa. Acompañado de chips. (+$20 aguacate)",
			},
			{
				nombre: "Panini Integral",
				precio: "$159",
				desc: "Panini con pechuga de pavo, queso panela, arugula y tomate cherry. (+$20 aguacate)",
			},
		],
	},
	{
		id: "smoothie",
		titulo: "the blend",
		subtitulo: "Cold · 16oz",
		emoji: "🫙",
		color: "#E84023",
		items: [
			{
				nombre: "Cacao Protein Smoothie",
				precio: "$159",
				desc: "Smoothie con proteína de cacao Habits, leche, crema de almendras, dátil y plátano. Endulzado con miel de agave.",
			},
			{
				nombre: "Strawberry Collagen Smoothie",
				precio: "$159",
				desc: "Smoothie de fresas con colágeno Vital Proteins, leche y yogurt griego. Endulzado con miel de agave.",
			},
		],
	},
	{
		id: "extras",
		titulo: "extras & add-ons",
		subtitulo: "Personaliza tu bebida",
		emoji: "➕",
		color: "#F07E2A",
		items: [
			{
				nombre: "Jarabe (Vainilla / Caramelo / Avellana / Agave / Fresa / Biscoff / Banana)",
				desc: "",
			},
			{ nombre: "Leche vegetal (Almendra / Avena / Coco)", desc: "" },
			{ nombre: "Cold Foam", desc: "" },
			{ nombre: "Shot Espresso Extra", desc: "" },
		],
	},
];

const Menu = () => {
	const [categoriaActiva, setCategoriaActiva] = useState("todos");

	const seccionesFiltradas =
		categoriaActiva === "todos"
			? secciones
			: secciones.filter((s) => s.id === categoriaActiva);

	return (
		<section className="menu" id="menu">
			<div className="container">
				<div className="section-header">
					<span className="section-tag">what makes us, us</span>
					<h2 className="section-title">
						our <span className="text-accent">menu</span>
					</h2>
					<p className="section-subtitle">
						tu dosis perfecta te está esperando
					</p>
				</div>

				<div className="menu__filtros">
					{categorias.map((cat) => (
						<button
							key={cat.id}
							className={`menu__filtro-btn ${categoriaActiva === cat.id ? "menu__filtro-btn--activo" : ""}`}
							onClick={() => setCategoriaActiva(cat.id)}
						>
							{cat.label}
						</button>
					))}
				</div>

				<div className="menu__secciones">
					{seccionesFiltradas.map((sec, i) => (
						<div className="menu__seccion" key={i}>
							<div
								className="menu__seccion-header"
								style={{ borderColor: sec.color }}
							>
								<span className="menu__seccion-emoji">
									{sec.emoji}
								</span>
								<div>
									<h3 className="menu__seccion-titulo">
										{sec.titulo}
									</h3>
									<span className="menu__seccion-subtitulo">
										{sec.subtitulo}
									</span>
								</div>
							</div>
							<div className="menu__items">
								{sec.items.map((item, j) => (
									<div className="menu__item" key={j}>
										<div className="menu__item-info">
											<span className="menu__item-nombre">
												{item.nombre}
											</span>
											{item.desc && (
												<span className="menu__item-desc">
													{item.desc}
												</span>
											)}
										</div>
									</div>
								))}
							</div>
						</div>
					))}
				</div>
			</div>
		</section>
	);
};

export default Menu;
